import React, { useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import WebViewer from '@pdftron/webviewer';
import { Box, Container } from '@tq/ui-components';

const pdfJsExpressLicense = process.env.REACT_APP_PDF_JS_EXPRESS_LICENSE as string;

export const Measure: React.FC = () => {
  const { path } = useParams();
  const viewerDiv = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const matches = path?.match(
      /^(.*)%3Fsv%3D(.*)%26se%3D(.*)%26sr%3D(.*)%26sp%3D(.*)%26sig%3D(.*)$/
    );
    const url = matches
      ? `${decodeURIComponent(matches[1])}?sv=${matches[2]}&se=${matches[3]}&sr=${
          matches[4]
        }&sp=${matches[5]}&sig=${matches[6]}`
      : path;

    WebViewer(
      {
        path: '/pdfjsexpress',
        initialDoc: url,
        enableMeasurement: true,
        disabledElements: [
          'ribbons',
          'toggleNotesButton',
          'contextMenuPopup',
          'annotationCommentButton',
        ],
        licenseKey: pdfJsExpressLicense,
      },
      viewerDiv.current as HTMLDivElement
    ).then((instance) => {
      instance.UI.setToolbarGroup('toolbarGroup-Measure');
    });
  }, [path]);

  return (
    <Container px={{ base: 0, lg: 4, xl: 0 }}>
      <Box
        ref={viewerDiv}
        position='absolute'
        width='100vw'
        height={{
          base: 'calc(100vh - 65px)',
          lg: 'calc(100vh - 69px)',
          xl: 'calc(100vh - 96px)',
        }}
        top={{ base: '65px', lg: '69px', xl: '96px' }}
        left={0}
      ></Box>
    </Container>
  );
};
